import { alert } from '@repo/ui/Alert'
import { debounce } from '@repo/utils/debounce'
import { formatThousands } from '@repo/utils/numbers'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { storeWrapper } from '../storeWrapper'
import { useDataGridFilterStore } from '@repo/store/useDataGridFilterStore'

const initialState = {
  clientsTableData: []
}

export const useClientTableStore = storeWrapper('useMatterTableStore', (set) => ({
  ...initialState,
  fetchClientsTableData: async () => {
    const { clientsTableFilters } = useDataGridFilterStore.getState()

    return new Promise((resolve) => {
      debounce({
        id: `fetchMatterTableData_${clientsTableFilters.clientMatterNo}`,
        delay: 300,
        callback: async () => {
          let data

          data = {
            orderByColumns: clientsTableFilters.orderByColumns ?? null,
            pageSize: clientsTableFilters.pageSize ?? 25,
            startAtIndex: clientsTableFilters.startAtIndex ?? 0,

            clientNo: clientsTableFilters.filters.clientNo ?? null,
            clientName: clientsTableFilters.filters.clientName ?? null,
            clientType: clientsTableFilters.filters.clientType ?? null,
            emailAddress: clientsTableFilters.filters.emailAddress ?? null,
            address: clientsTableFilters.filters.address ?? null,
            highRisk: clientsTableFilters.filters.highRisk ?? null
          }

          let fetchedClientsTableData

          try {
            fetchedClientsTableData =
              (await ospreyAPI({
                method: 'POST',
                service: 'matters',
                endpoint: 'Client/GetAllExtendedBySearchCriteria',
                data: data
              })) || {}
          } catch (err) {
            console.log('Error:', err)
            return
          }

          set({ clientsTableData: fetchedClientsTableData })
          resolve(fetchedClientsTableData)
        }
      })
    })
  },
  fetchClientsTableAsCSV: async () => {
    const { clientsTableFilters } = useDataGridFilterStore.getState()

    return new Promise((resolve) => {
      debounce({
        id: `fetchClientTableData_CSV`,
        delay: 300,
        callback: async () => {
          let data

          data = {
            orderByColumns: clientsTableFilters.orderByColumns ?? null,
            pageSize: clientsTableFilters.pageSize ?? 25,
            startAtIndex: clientsTableFilters.startAtIndex ?? 0,

            clientNo: clientsTableFilters.filters.clientNo ?? null,
            clientName: clientsTableFilters.filters.clientName ?? null,
            clientType: clientsTableFilters.filters.clientType ?? null,
            emailAddress: clientsTableFilters.filters.emailAddress ?? null,
            address: clientsTableFilters.filters.address ?? null,
            highRisk: clientsTableFilters.filters.highRisk ?? null
          }

          let fetchedClientsTableDataCSV

          try {
            fetchedClientsTableDataCSV =
              (await ospreyAPI({
                method: 'POST',
                service: 'matters',
                endpoint: 'Client/GetAllExtendedBySearchCriteriaAsCSV',
                data: data,
                suppressErrorToast: true
              })) || {}
          } catch (err) {
            if (err.status === 422) {
              alert(
                `You have selected ${formatThousands(clientsTableFilters.totalRowCount || 0)} records, but this feature is limited to ${formatThousands(10000)} records. Please refine your search to include fewer results, or contact support@ospreyapproach.com if you require further assistance`
              )
              return
            } else {
              alert('Error:', err)
            }
            console.log('Error:', err)
            return
          }

          const blob = new Blob([fetchedClientsTableDataCSV], { type: 'text/csv' })

          const blobUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl
          link.download = 'client_export.csv'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          URL.revokeObjectURL(blobUrl)

          resolve(fetchedClientsTableDataCSV)
        }
      })
    })
  },
  reset: () => set(initialState)
}))
